import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BusTypeController from "../../../../services/system/bus/bus-type-controller";
import Utils from "../../../../utils/utils";
import LatePickUpController from "../../../../services/system/late-pick-up/late-pick-up-controller";

class ModalEditConfigLate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: -1,
            fromDate: '',
            toDate: '',
            name: '',
            price: 0,
            status: true,
            state: "ACTIVE"
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState({showLoading: true},
                () => {
                    this.state = {
                        id: nextProps.id,
                    };
                    this.detailLatePickUp(nextProps.id)
                }
            )
        }
    }
    detailLatePickUp(id) {
        LatePickUpController.detail(id, res => {
            if (res.success) {
                let data = res.data;
                let fromDate = data.startHour+":"+ data.startMinute
                let toDate = data.endHour+":"+ data.endMinute
                data["fromDate"] = fromDate
                data["toDate"] = toDate
                this.setState(
                    data
                );
            } else {
                toast.error(res.message[0] =="FORBIDDEN"? "Bạn không có quyền thực hiện chức năng này!" : res.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000
                });
            }
        });
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "ACTIVE",
                "name": "Hoạt động"
            },
            {
                "id": "INACTIVE",
                "name": "Dừng hoạt động"
            },
            {
                "id": "LOCK",
                "name": "Đang khóa"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    editLatePickUp = () => {
        let price = parseFloat(this.state.price.toString().replaceAll(",", ""))
        if (this.state.code.length < 3){
            toast.error("Mã cấu hình phải hơn hơn 3 ký tự", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if (price < 1000){
            toast.error("Vui lòng nhập giá!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if(!Utils.checkFormatTime(this.state.fromDate)){
            toast.error("Định dang giờ bắt đầu không đúng", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if(!Utils.checkFormatTime(this.state.toDate)){
            toast.error("Định dang giờ kết thúc không đúng", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else {
            let listFrom = this.state.fromDate.toString().split(":")
            let listTo = this.state.toDate.toString().split(":")
            let payload = {
                "startHour": parseInt(listFrom[0]),
                "startMinute": parseInt(listFrom[1]),
                "endHour": parseInt(listTo[0]),
                "endMinute": parseInt(listTo[1]),
                "code": this.state.code,
                "price": price,
                "state": this.state.state,
                "id": this.state.id
            }
            LatePickUpController.edit(payload, res => {
                if (res.success) {
                    toast.success("Thêm cấu hình đón muộn thành công!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                    this.props.onHide();
                    this.props.onRefresh()
                } else {
                    toast.error("Có lỗi xảy ra!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                }
            })
        }
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Thêm mới cấu hình đón muộn</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">

                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Mã cấu hình(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        maxLength={255}
                                        type="text"
                                        placeholder="Nhập mã cấu hình"
                                        className="form-control shadow-none"
                                        value={this.state.code}
                                        onChange={(event) => {
                                            this.setState({
                                                code: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Thời gian(<span  style={{color: "red",}}>*</span>)</label>

                                </div>
                                <div className="col-6 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Từ</label>
                                    <input
                                        maxLength={255}
                                        type="text"
                                        placeholder="VD: 17:30"
                                        className="form-control shadow-none"
                                        value={Utils.formatTime(this.state.fromDate)}
                                        onChange={(event) => {
                                            this.setState({
                                                fromDate: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-6 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Tới</label>
                                    <input
                                        maxLength={255}
                                        type="text"
                                        placeholder="VD: 18:30"
                                        className="form-control shadow-none"
                                        value={Utils.formatTime(this.state.toDate)}
                                        onChange={(event) => {
                                            this.setState({
                                                toDate: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Giá(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        placeholder="Nhập giá"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={Utils.formatMoney(this.state.price)}
                                        onChange={(event) => {
                                            this.setState({
                                                price: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex">
                                    <label className="label-item col-4">Trạng thái</label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.state}
                                        onChange={(e) => {
                                            this.state.state = e.target.value;
                                            this.setState({
                                                state: e.target.value
                                            })
                                        }}
                                    >
                                        {this.renderStatus()}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.editLatePickUp()}
                                >
                                        <span className='justify-content-center'>
                                            Lưu
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Đóng
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalEditConfigLate